import { keysToSnakeCaseDeep } from '@frontend/utils';

import type { HasExtendedBody } from '../types';
import { getBodyIsUnsupportedType } from './getBodyIsUnsupportedType';
import { getIsBodyJsonSerializableObject } from './getIsBodyJsonSerializableObject';

export const composeRequestBody = (
  body: HasExtendedBody['body'],
): {
  body: RequestInit['body'];
  headerOverrides?: RequestInit['headers'];
} => {
  if (getIsBodyJsonSerializableObject(body)) {
    return {
      body: JSON.stringify(keysToSnakeCaseDeep(body)),
      headerOverrides: {
        'Content-Type': 'application/json',
      },
    };
  }

  if (getBodyIsUnsupportedType(body)) {
    return {
      body: undefined,
    };
  }

  return {
    body,
  };
};
